import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Connects to data-controller="consumer"
export default class extends Controller {
  static outlets = ["slideover"];
  static targets = ["addToCartButton", "productSizeButton", "productVariantButton"];

  addToCart(event) {
    const button = event.currentTarget;
    const text = button.querySelector("span");
    const spinner = button.querySelector("svg");
    button.setAttribute("disabled", "true");
    text.classList.add("hidden");
    spinner.classList.remove("hidden");

    const activeVariantId = document.querySelector("[data-active-variant='true']")?.dataset.recordId;
    const activeSizeId = document.querySelector("[data-active-size='true']")?.dataset.recordId;
    const productId = button.dataset.productId;

    if (activeVariantId && activeSizeId && productId) {
      post(button.dataset.url, {
        body: JSON.stringify({
          product_item: {
            product_id: productId,
            product_size_id: activeSizeId,
            product_variant_id: activeVariantId,
          },
        }),
      })
        .then((response) => {
          if (response.ok) {
            this.slideoverOutlet.open();
          } else {
            alert("Something went wrong, refresh and try again.");
          }
        })
        .catch(() => {
          alert("Something went wrong, refresh and try again.");
        });
    } else {
      alert("Something went wrong, refresh and try again.");
    }
  }

  toggleProductSize(event) {
    this.productSizeButtonTargets.forEach((button) => {
      const isCurrentButton = button === event.currentTarget;
      button.dataset.activeSize = isCurrentButton;
    });

    this.addToCartButtonTarget.parentElement.dataset.controller = null;
    this.addToCartButtonTarget.removeAttribute("disabled");
  }

  toggleVariant(event) {
    const needstoSwapImage = event.currentTarget.dataset.activeVariant == "false";

    if (needstoSwapImage) {
      post(event.currentTarget.dataset.swapImageUrl);
    }

    this.productVariantButtonTargets.forEach((button) => {
      const isCurrentButton = button === event.currentTarget;
      button.dataset.activeVariant = isCurrentButton;
    });
  }

  updateQuantity(e) {
    if (!e.currentTarget.value.trim()) {
      alert("Please enter a valid number");
      e.currentTarget.value = this.previousValue;
      e.currentTarget.form.reset();
    } else {
      e.currentTarget.form.requestSubmit();
    }
  }
}
